import { useEffect, useState } from 'react'
import { PageHeader, StateBlock } from '../../shared/StateBlock'
import { ResponsiveTable } from '../../shared/ResponsiveTable'
import { ibApi, IbApiError } from '../api'

type SymbolRow = {
  symbol: string
  buyLots: number
  sellLots: number
  buyAvg: number
  sellAvg: number
  netLots: number
}

export function IbPositionsPage() {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [rows, setRows] = useState<SymbolRow[]>([])
  const [errors, setErrors] = useState(0)

  useEffect(() => {
    void (async () => {
      setLoading(true)
      setError('')
      try {
        const data = await ibApi.netPositions()
        setRows(data.symbols || [])
        setErrors(data.errors || 0)
      } catch (err) {
        setError(err instanceof IbApiError ? err.message : 'Unable to load net positions')
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  return (
    <div>
      <PageHeader eyebrow="IB portal" title="Net positions">
        <p className="cp-muted">
          Open PREDGOLD_* exposure across your referred clients (buy/sell lots + average).
        </p>
      </PageHeader>

      {error ? (
        <StateBlock tone="error" title="Error">
          {error}
        </StateBlock>
      ) : null}
      {!loading && !error && errors > 0 ? (
        <StateBlock tone="warn" title="Partial data">
          Some accounts could not be read from the bridge ({errors}).
        </StateBlock>
      ) : null}
      {loading ? (
        <p className="cp-muted ap-inline-status" aria-live="polite">
          Loading positions…
        </p>
      ) : null}

      <div className={`cp-panel${loading ? ' is-refreshing' : ''}`}>
        <ResponsiveTable
          rowKey={(r) => r.symbol}
          columns={[
            { key: 'symbol', header: 'Symbol', render: (r) => r.symbol },
            { key: 'buyLots', header: 'Buy lots', render: (r) => r.buyLots.toFixed(2) },
            { key: 'buyAvg', header: 'Buy avg', render: (r) => r.buyAvg.toFixed(2) },
            { key: 'sellLots', header: 'Sell lots', render: (r) => r.sellLots.toFixed(2) },
            { key: 'sellAvg', header: 'Sell avg', render: (r) => r.sellAvg.toFixed(2) },
            { key: 'netLots', header: 'Net lots', render: (r) => r.netLots.toFixed(2) },
          ]}
          rows={rows}
          empty={loading ? 'Loading…' : 'No open PREDGOLD positions.'}
        />
      </div>
    </div>
  )
}
